export default __webpack_public_path__ + "2dc882049f11c5fd640407a8efe2f48f.png";